// Generated image metadata is produced from docs/_data/image-manifest.json by scripts/build-images.mjs.
import { generatedImages } from './images.generated'

declare const __QB_AVAILABLE_DECORATIONS__: readonly string[] | undefined

export type ImageVariant = {
  format: 'jpg' | 'png' | 'webp'
  width: number
  height: number
  src: string
}

export type ImageMetadata = {
  width: number
  height: number
  variants: readonly ImageVariant[]
}

export const imageMetadata: Readonly<Record<string, ImageMetadata>> = generatedImages
const availableDecorations = new Set(
  typeof __QB_AVAILABLE_DECORATIONS__ === 'undefined' ? [] : __QB_AVAILABLE_DECORATIONS__,
)

export function imageBase(src: string): string {
  const withoutQuery = src.split(/[?#]/u, 1)[0]
  return withoutQuery
    .replace(/-\d+\.(?:jpe?g|png|webp)$/iu, '')
    .replace(/\.(?:jpe?g|png|webp)$/iu, '')
}

export function getImageMetadata(src: string): ImageMetadata | undefined {
  return imageMetadata[imageBase(src)]
}

export function decoExists(src: string): boolean {
  const base = imageBase(src)
  return base.startsWith('/img/deco/') && availableDecorations.has(base) && Boolean(getImageMetadata(src))
}
